import { ajax } from '../../../services/helper'
class ApiService {

    getPrivilegesData = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/privileges/list"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



    getRolesComboList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/roles/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


   
      addPrivilege = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/privileges/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

      getPrivilegesById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/privileges/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     editPrivilege = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/privileges/"+id+"/edit"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    

    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Privileges/services/apiservices.js